// extracted by mini-css-extract-plugin
export default {"paginator":"Paginator_paginator__nDK9Q","page":"Paginator_page__FNDKJ","selectedPage":"Paginator_selectedPage__CRNLp","paginatorBtn":"Paginator_paginatorBtn__fk2Sc"};